import { render } from "./EmailOptIn.vue?vue&type=template&id=1081457b&scoped=true"
import script from "./EmailOptIn.vue?vue&type=script&lang=js"
export * from "./EmailOptIn.vue?vue&type=script&lang=js"

import "./EmailOptIn.vue?vue&type=style&index=0&id=1081457b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081457b"]])

export default __exports__